export default __webpack_public_path__ + "locales/lv/ChangeUserStatusDialog.json?hash=6a81e4ff27d6499a9bde33cc4a41e99d";